import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useAddStratgeic } from "features/events/use-cases/addupdatestrategicpartner";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

type Props = {
  onClose: () => void;
  refetch: () => void;
  strategicPartnerData?: any;
  mode: "add" | "edit"; // ✅ explicit mode
};

const AddStrategicPartnerModal = ({
  onClose,
  refetch,
  strategicPartnerData,
  mode,
}: Props) => {
  const { id } = useParams();
  const [form] = Form.useForm();

  const { mutate: addStrategicPartner, isLoading } =
    useAddStratgeic(id);

  // ✅ SET / RESET FORM
  useEffect(() => {
    if (mode === "edit" && strategicPartnerData) {
      form.setFieldsValue({
        title: strategicPartnerData.Title,
        titleAr: strategicPartnerData.TitleAr,
      });
    } else {
      form.resetFields();
    }
  }, [mode, strategicPartnerData, form]);

  const handleSubmit = (values: any) => {
    const payload = {
      LoginUserId: 1,
      EventId: Number(id),
      Title: values.title || "",
      TitleAr: values.titleAr || "",
    };

    addStrategicPartner(payload, {
      onSuccess: async () => {
        form.resetFields();
        await refetch?.();
        onClose?.();
      },
      // onError: (err) => {
      //  // console.log("Error:", err);
      // },
    });
  };

  return (
    <div className="custom-overlay">
      <div className="custom-modal">
        {/* ✅ HEADER */}
        <div className="modal-header">
          <span>
            {mode === "edit"
              ? "Edit Strategic Partner"
              : "Add Strategic Partner"}
          </span>

          <CloseOutlined
            onClick={() => {
              form.resetFields();
              onClose?.();
            }}
          />
        </div>

        {/* ✅ FORM */}
        <div style={{ padding: "20px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            disabled={isLoading}
          >
            <Form.Item
              label="English Name"
              name="title"
              rules={[{ required: true, message: "Please enter name" }]}
            >
              <Input placeholder="Enter partner name" />
            </Form.Item>

            <Form.Item
              label="Arabic Name"
              name="titleAr"
              rules={[{ required: true, message: "Please enter Arabic name" }]}
            >
              <Input placeholder="ادخل اسم الشريك" />
            </Form.Item>

            <div className="modal-footer">
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddStrategicPartnerModal;